const HEADING_FONT_FAMILY = [
    "Barlow Semi Condensed",
    "sans-serif",
].join(',');

const getTypography = () => {
    return {
        fontFamily: [
            "Barlow",
            "sans-serif",
        ].join(','),
        h1: {
            fontSize: "2.70rem",
            fontFamily: HEADING_FONT_FAMILY,
            fontWeight: "bold",
        },
        h2: {
            fontSize: "2.35rem",
            fontFamily: HEADING_FONT_FAMILY,
            fontWeight: "bold",
        },
        h3: {
            fontSize: "1.90rem",
            fontFamily: HEADING_FONT_FAMILY,
            fontWeight: "bold",
        },
        h4: {
            fontSize: "1.60rem",
            fontFamily: HEADING_FONT_FAMILY,
            fontWeight: "bold",
        },
        h5: {
            fontSize: "1.3rem",
            fontFamily: HEADING_FONT_FAMILY,
            fontWeight: "bold",
        },
        h6: {
            fontSize: "1.2rem",
            fontFamily: HEADING_FONT_FAMILY,
        },
    }
}

export default getTypography;
